export const TARIFF_LOADING = "BIKE_LOADING";
export const TARIFF_ERROR = "BIKE_ERROR";
export const TARIFF_GET_LIST = "TARIFF_GET_LIST";
export const TARIFF_RESET_LIST = "TARIFF_RESET_LIST";
export const TARIFF_ADD = "TARIFF_ADD";
export const TARIFF_GET_TYPES = "TARIFF_GET_TYPES";



// WEBPACK FOOTER //
// ./src/actions/tariff/constants.js